import React, { useEffect, useRef, useState } from "react";
// import CarouselComercial from "../Home/Carousel/CarouselComercial"
import { Carousel, Typography } from "@material-tailwind/react";
import { Helmet } from "react-helmet";

// import Picture1 from '../../uploads/Photos/Header-Photos/CarouselHome/windfree_room01.webp'
// import Picture2 from '../../uploads/Photos/Header-Photos/CarouselHome/room01.webp'
// import Picture3 from '../../uploads/Photos/Header-Photos/CarouselHome/out_room01.webp'
// import Picture4 from '../../uploads/Photos/Header-Photos/CarouselHome/Feature_Visual_2.webp'

// const pictures = [Picture1, Picture2, Picture3, Picture4];

const images = require.context("../../uploads/Photos/Header-Photos/CarouselHome", false, /\.(webp|jpg|png|jpeg)$/);

const image_list = images.keys().map((imagePath) => images(imagePath).default || images(imagePath));

export default function HomeSolutions() {
    const [imageVisible, setImageVisible] = useState(false);
    const [isIos, setIsIos] = useState(false);
    const imageContainerRef = useRef(null);

    const detectIos = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        setIsIos(true);
    }
    };

      useEffect(() => {
        detectIos();
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                entry.target.classList.add('blur-none');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.8 }
        );
    
        if (imageContainerRef.current) {
          observer.observe(imageContainerRef.current);
        }
    
        return () => {
          if (imageContainerRef.current) {
            observer.unobserve(imageContainerRef.current);
          }
        };
      }, []);

    return (
    <>
      <Helmet>
        <title>EES | Решенија за Вашиот Дом</title>
        <meta name="title" content="Решенија за Вашиот Дом | Удобност и Иновативност" />
        <meta name="description" content="Погледнете ги нашите решенија за вашиот дом кои нудат максимална удобност и напредна технологија." />
        <meta name="keywords" content="решенија за дом, удобност, иновации, технологија" />
      </Helmet>
        <div ref={imageContainerRef} id='image-container' >
            <Carousel
                autoplay={true}
                autoplayDelay={6000}
                loop={true}
                className='h-5/6'
                navigation={({ setActiveIndex, activeIndex, length }) => (
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-50">
                    {new Array(length).fill("").map((_, i) => (
                    <span
                        key={i}
                        className={`block h-1 cursor-pointer transition-all duration-300 rounded-md ${
                        activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"
                        }`}
                        onClick={() => setActiveIndex(i)}
                    />
                    ))}
                </div>
                )}
            >
                {image_list.map((image_url, index) => (
                <div className="relative h-full w-full">
                <img
                    src={image_url}
                    alt={`Slide ${index + 1}`}
                    className="h-full w-full object-cover"
                />
                {/* <div className="absolute inset-0 grid h-full w-full place-items-center">
                </div> */}
                </div>
            ))}
            </Carousel>
            <div className="px-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-[95%] xl:max-w-[90%] md:px-24 lg:px-8 mt-5 sm:mt-5 md:mt-10 lg:mt-7">
                <Typography
                    color="black"
                    className="text-start text-xl sm:text-3xl md:text-4xl"
                    >
                        Решенија за вашиот дом
                </Typography>
            </div>
        </div>
            {/* <div
            style={{ background: '#f7f7f7' }}
            className="py-16 px-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-[95%] xl:max-w-[90%] md:px-24 lg:px-8 rounded-3xl rounded-b-md mt-10"
            >
                <Typography
                variant="h2"
                color="black"
                className="text-start"
                >
                    Наши проекти
                </Typography>
            </div> */}
    </>
    )
}